export const meta = {
  title: '隐私政策 | WordCraftApp',
  description:
    'WordCraftApp 如何处理下载指南、在线编辑器、基础教程和支持请求相关的信息。',
  updated_at: '2026-10-15',
};

## 关于本政策

WordCraftApp 运营 wordcraftapp.com，提供 WordCraft 英文下载指南、在线使用入口、基础操作教程，以及与 Microsoft Word 的对比。WordCraft 由 ArtCraft 开发，本站与 ArtCraft 或 Microsoft 无隶属关系。

本政策适用于本站和本站托管的 WordCraft 网页版。隐私问题或请求请联系 [support@wordcraftapp.com](mailto:support@wordcraftapp.com)。

## 在线使用 WordCraft

[在线编辑器](/app/index.html) 在浏览器中运行 WordCraft 网页版。打开本地文档时，文件在浏览器中处理；WordCraftApp 不提供文档上传或云存储服务。请将工作保存或导出到设备，并自行备份。

浏览器加载编辑器所需文件时，托管服务商会收到正常的连接信息。浏览器存储可能保留应用偏好或缓存资源，清理浏览器数据可能移除这些内容。你主动发送给支持邮箱的文档或截图会作为支持往来处理。

## 下载

[下载指南](/download) 链接到开发者在 GitHub 上发布的 WordCraft 文件。访问链接会向 GitHub 发送请求，其处理方式见 [GitHub 隐私声明](https://docs.github.com/en/site-policy/privacy-policies/github-general-privacy-statement)。外部产品页面和社区服务遵循各自的隐私做法。

## 网站处理的信息

- **访问与安全：** 托管及安全服务可能处理 IP 地址、浏览器和设备信息、请求地址、来源信息及时间，用于提供页面、排查问题和防止滥用。
- **可选账号：** 如使用登录功能，我们会处理姓名、邮箱、密码哈希和会话信息。阅读指南、访问下载链接及启动编辑器无需本站账号。
- **支持请求：** 我们会处理你的邮箱、消息，以及你主动提供的信息或附件。反馈失效链接或教程问题通常只需页面地址和问题说明。
- **可选集成：** 如启用统计、广告或聊天工具，相关服务可能按配置处理页面交互、设备信息和标识符。这些工具不代表本站提供文档云存储。

## Cookie 与浏览器存储

登录功能使用 Cookie 维持会话。网站也可能存储外观偏好及来源信息。网站以英文显示，无需语言选择 Cookie。

启用的统计、广告或聊天服务可能使用自己的 Cookie 或浏览器存储。你可以通过浏览器管理这些数据。禁用必要 Cookie 可能影响登录，清理网站存储可能重置偏好。

## 信息使用与共享

我们使用信息来运行和保护 WordCraftApp、维护可选账号、改进指南并回复支持请求。服务商可能按托管、安全、邮件及已启用集成的需要处理信息。Cloudflare 托管的相关做法见 [Cloudflare 隐私政策](https://www.cloudflare.com/privacypolicy/)。服务商可能在你所在国家以外处理信息。

我们不提供访客信息出售。适用法律要求，或为保护网站及用户而合理必要时，我们可能披露信息。

## 保留与安全

我们按收集目的所需期限保留信息，包括处理支持请求、维护有效账号、保护网站和满足适用法律义务。我们采用访问控制和会话保护措施，但没有完全安全的存储或传输方式。

## 你的选择与隐私请求

你可以管理浏览器存储、选择是否使用可选账号，并向 [support@wordcraftapp.com](mailto:support@wordcraftapp.com) 请求访问、更正或删除与你有关的信息。根据适用法律，你可能还享有反对某些处理或向数据保护机构投诉等权利。我们可能要求提供核实请求确实涉及你本人数据所需的信息。

## 变更

我们可能随网站和服务变化更新本政策。页面顶部的最后更新日期标识当前版本。有关网站或本政策的问题，请联系 [support@wordcraftapp.com](mailto:support@wordcraftapp.com)。
